var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "d-flex align-items-center text-center mt-4" },
    [
      _c(
        "div",
        { staticClass: "w-100" },
        [
          _c("v-card-title", { staticClass: "card-title" }, [
            _vm._v(" Datos Laborales "),
          ]),
          _c(
            "v-card-text",
            [
              _c(
                "v-row",
                { staticClass: "pa-3" },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("BaseCombobox", {
                        attrs: {
                          label: "Sucursal*",
                          name: "sucursal",
                          items: _vm.sucursales,
                          "item-text": "name",
                          "item-value": "id",
                          loading: _vm.loading_sucursales,
                          rules: "required|combobox_required",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.sucursal,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "sucursal", $$v)
                          },
                          expression: "legajo.sucursal",
                        },
                      }),
                      _c("BaseInput", {
                        attrs: {
                          label: "Referencia externa",
                          name: "external_reference",
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.external_reference,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "external_reference", $$v)
                          },
                          expression: "legajo.external_reference",
                        },
                      }),
                      _vm.legajo.id != 0
                        ? _c("BaseDatePicker", {
                            attrs: {
                              label: "Fecha de baja",
                              name: "finish_date",
                              rules: "",
                              validationErrors: _vm.errors,
                            },
                            model: {
                              value: _vm.legajo.finish_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.legajo, "finish_date", $$v)
                              },
                              expression: "legajo.finish_date",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("BaseCombobox", {
                        attrs: {
                          label: "Sector",
                          name: "worksector",
                          items: _vm.worksectors,
                          "item-text": "name",
                          "item-value": "id",
                          loading: _vm.loading_worksectors,
                          rules: "combobox",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.worksector,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "worksector", $$v)
                          },
                          expression: "legajo.worksector",
                        },
                      }),
                      _c("BaseDatePicker", {
                        attrs: {
                          label: "Fecha de ingreso*",
                          name: "hire_date",
                          rules: "required",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.hire_date,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "hire_date", $$v)
                          },
                          expression: "legajo.hire_date",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("BaseCombobox", {
                        attrs: {
                          label: "Puesto",
                          name: "workstation",
                          items: _vm.workstations,
                          "item-text": "name",
                          "item-value": "id",
                          loading: _vm.loading_workstations,
                          rules: "",
                          validationErrors: _vm.errors,
                        },
                        model: {
                          value: _vm.legajo.workstation,
                          callback: function ($$v) {
                            _vm.$set(_vm.legajo, "workstation", $$v)
                          },
                          expression: "legajo.workstation",
                        },
                      }),
                      _vm.legajo.id != 0
                        ? _c("BaseDatePicker", {
                            attrs: {
                              label: "Fecha de alta",
                              name: "creation_date",
                              rules: "",
                              validationErrors: _vm.errors,
                            },
                            model: {
                              value: _vm.legajo.creation_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.legajo, "creation_date", $$v)
                              },
                              expression: "legajo.creation_date",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }